import React from 'react';
import { Coffee, Sun, Moon, Apple, BookOpen, Calendar } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: <Coffee className="w-5 h-5" data-id="element-177" />,
    title: 'Desayunos',
    desc: 'Simples, nutritivos, sin inflamación'
  }, {
    icon: <Sun className="w-5 h-5" data-id="element-178" />,
    title: 'Almuerzos',
    desc: 'Combinaciones que digieren bien'
  }, {
    icon: <Moon className="w-5 h-5" data-id="element-179" />,
    title: 'Cenas',
    desc: 'Livianas, ricas, sin hincharte al otro día'
  }, {
    icon: <Apple className="w-5 h-5" data-id="element-180" />,
    title: 'Meriendas y picoteos',
    desc: 'Para que no llegues con hambre a la cena'
  }, {
    icon: <BookOpen className="w-5 h-5" data-id="element-181" />,
    title: 'Guía de combinaciones',
    desc: 'Qué va con qué, y qué nunca juntar'
  }, {
    icon: <Calendar className="w-5 h-5" data-id="element-182" />,
    title: 'Calendario de 28 días',
    desc: 'Un día a la vez. Listo para seguir'
  }];
  return <section className="py-20 bg-white" data-id="element-183">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto" data-id="element-185">
          {/* Content */}
          <div data-id="element-186">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-187">
              ¿Qué recibís exactamente?
            </h2>

            <div className="bg-emerald-50 p-6 rounded-xl mb-8 border border-emerald-100" data-id="element-188">
              <h3 className="text-xl font-bold text-emerald-900 mb-2" data-id="element-189">
                📘 LIBRO PRINCIPAL — Método 28 Días sin Inflamación
              </h3>
              <p className="text-emerald-800" data-id="element-190">
                Plan completo día por día con recetas y combinaciones
                antiinflamatorias.
              </p>
            </div>

            <div className="space-y-4" data-id="element-191">
              {items.map((item, idx) => <div key={idx} className="flex items-center p-4 bg-white border border-gray-100 rounded-lg shadow-sm hover:border-emerald-200 transition-colors" data-id="element-192">
                  <div className="bg-emerald-100 p-3 rounded-full text-emerald-600 mr-4 flex-shrink-0" data-id="element-193">
                    {item.icon}
                  </div>
                  <div data-id="element-194">
                    <h4 className="font-bold text-gray-900" data-id="element-195">{item.title}</h4>
                    <p className="text-sm text-gray-600" data-id="element-196">{item.desc}</p>
                  </div>
                </div>)}
            </div>

            <p className="mt-8 text-lg text-gray-700 italic border-l-4 border-emerald-500 pl-4" data-id="element-197">
              "Todo simple. Todo real. Todo aplicable a tu vida — aunque no
              tengas tiempo, no sepas cocinar o tengas familia a cargo."
            </p>
          </div>

          {/* Mockup Image Placeholder */}
          <div className="relative" data-id="element-198">
            <div className="aspect-[4/5] bg-stone-100 rounded-2xl shadow-2xl border-8 border-white overflow-hidden relative group" data-id="element-199">
              <img src="https://cdn.magicpatterns.com/uploads/x8JDjTRDcerr6NBMtVrZui/ChatGPT_Image_21_ene_2026,_20_20_09.png" alt="Reto 28 Días sin Inflamación" className="w-full h-full object-cover object-center" data-id="element-200" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -z-10 top-10 -right-10 w-full h-full bg-emerald-100 rounded-2xl" data-id="element-201"></div>
            <div className="absolute -z-20 -bottom-10 -left-10 w-40 h-40 bg-yellow-100 rounded-full blur-3xl opacity-50" data-id="element-202"></div>
          </div>
        </div>
      </div>
    </section>;
}